class VariantImageFilter {
  constructor() {
    this.delimiter = '#';
  }

  parseAltText(altText) {
    if (!altText || typeof altText !== 'string') return {};

    const delimiterIndex = altText.indexOf(this.delimiter);
    if (delimiterIndex === -1) return {};

    const variantPart = altText.substring(delimiterIndex + 1).trim();
    if (!variantPart) return {};

    const options = {};

    const regex = /(\w+(?:\s+\w+)*?):([\w\s\-&]+?)(?=\s+\w+:|$)/gi;
    let match;

    while ((match = regex.exec(variantPart)) !== null) {
      const optionName = match[1].trim().toLowerCase();
      const optionValue = match[2].trim().toLowerCase();
      if (optionName && optionValue) {
        options[optionName] = optionValue;
      }
    }

    return options;
  }

  matchesVariant(imageOptions, selectedOptions) {
    if (Object.keys(imageOptions).length === 0) return false;

    for (const [optionName, optionValue] of Object.entries(imageOptions)) {
      const selectedValue = selectedOptions[optionName];

      if (!selectedValue) continue;

      if (selectedValue !== optionValue) return false;
    }

    return true;
  }

  filterMedia(mediaItems, variant, productOptions) {
    if (!variant || !mediaItems || mediaItems.length === 0) {
      return mediaItems;
    }

    const selectedOptions = {};
    if (variant.options && productOptions) {
      variant.options.forEach((value, index) => {
        const optionName = productOptions[index];
        if (optionName && value) {
          selectedOptions[optionName.toLowerCase()] = value.toLowerCase();
        }
      });
    }

    const matchingItems = [];

    mediaItems.forEach((item) => {
      const altText = item.getAttribute('data-media-alt') ||
                     item.querySelector('img')?.alt ||
                     '';

      const imageOptions = this.parseAltText(altText);

      if (this.matchesVariant(imageOptions, selectedOptions)) {
        matchingItems.push(item);
      }
    });

    if (matchingItems.length === 0) {
      if (variant.featured_media) {
        const featuredItem = Array.from(mediaItems).find(item => {
          const mediaId = item.getAttribute('data-media-id');
          return mediaId && parseInt(mediaId) === variant.featured_media.id;
        });

        if (featuredItem) {
          return [featuredItem];
        }
      }
      return mediaItems;
    }

    return matchingItems;
  }

  getUntaggedMedia(mediaItems) {
    return Array.from(mediaItems).filter(item => {
      const altText = item.getAttribute('data-media-alt') ||
                     item.querySelector('img')?.alt ||
                     '';
      const imageOptions = this.parseAltText(altText);
      return Object.keys(imageOptions).length === 0;
    });
  }

  getProductOptionNames(product) {
    if (!product || !product.options) return [];
    return product.options.map(option => option.name || option);
  }
}

if (typeof window !== 'undefined') {
  window.VariantImageFilter = VariantImageFilter;
}
